import Reveal from '@/components/feature/Reveal';

export default function CtaBand() {
  return (
    <section className="border-b border-background-200 bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-8 rounded-lg bg-primary-600 px-6 py-10 md:flex-row md:items-center md:justify-between md:px-12 md:py-12">
            <div className="max-w-2xl">
              <span className="font-label text-[11px] uppercase tracking-[0.25em] text-primary-100">
                Contribute
              </span>
              <h2 className="mt-4 font-heading text-2xl font-black leading-tight text-background-50 md:text-3xl">
                手上也有一条可核对的线索？
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-primary-100 md:text-base">
                欢迎提供带时间与出处的公开素材。我们会先查重、再补全证据链，
                确认可公开核对后才纳入相应合集，不采纳无法溯源的传闻。
              </p>
            </div>

            <div className="flex shrink-0 flex-col gap-3 sm:flex-row md:flex-col">
              <a
                href="#collections"
                className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 text-sm text-primary-700 transition-colors hover:bg-background-100"
              >
                <i className="ri-send-plane-line" />
                提交线索
              </a>
              <a
                href="#keywords"
                className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-200 px-6 text-sm text-background-50 transition-colors hover:bg-primary-700"
              >
                <i className="ri-book-open-line" />
                查看收录准则
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}